import { InjectionToken, StaticProvider } from '@angular/core';
import { assetPath } from './environments/environment';

export const globalStyles: string = '{{__embedded_stylesheet_content__}}';
export const externalStyles: string[] = [
  // Place external style URLS for use with ShadowStyleDirective here
  // The lower the index position, the higher the priority of the styles
  `${assetPath}/assets/solid-styles.css`,
  `${assetPath}/assets/solid-components.css`,
  `${assetPath}/assets/font.css`,
  `${assetPath}/assets/normalize.css`,
];

export const GLOBAL_STYLES = new InjectionToken<string>('global styles');
export const EXTERNAL_STYLES = new InjectionToken<string[]>('external styles');

export function injectGlobalStyles(): void {
  const globalStylesElement: HTMLStyleElement = document.createElement('style');
  globalStylesElement.innerHTML = globalStyles;
  document.head.appendChild(globalStylesElement);
}

export function provideStyles(): StaticProvider[] {
  return [
    { provide: GLOBAL_STYLES, useValue: globalStyles },
    { provide: EXTERNAL_STYLES, useValue: externalStyles },
  ];
}
